<template>
  <div class="table-page-wrapper">
    <div v-show="searchStatus" class="search-wrapper">
      <el-date-picker
        v-model="date"
        @change="changeDate"
        style="margin-right: 15px"
        type="monthrange"
        range-separator="至"
        start-placeholder="开始月份"
        end-placeholder="结束月份"
      >
      </el-date-picker>
      <el-date-picker
        v-model="tableParams.businessMonth"
        type="month"
        placeholder="选择业务月份"
        format="YYYYMM"
        value-format="YYYYMM"
        style="margin-right: 15px"
      >
      </el-date-picker>
      <el-select
        v-model="tableParams.isPayment"
        clearable
        placeholder="请选择是否支付"

        filterable
      >
        <el-option label="是" :value="0" :key="0"></el-option>
        <el-option label="否" :value="1" :key="1"></el-option>
      </el-select>
      <el-select
        v-model="tableParams.invoiceContent"
        clearable
        placeholder="请选择发票类型"

        filterable
      >
        <el-option label="信息服务费" :value="0" :key="0"></el-option>
        <el-option label="广告发布费" :value="1" :key="1"></el-option>
        <el-option label="技术服务费" :value="2" :key="2"></el-option>
        <el-option label="其他费用" :value="3" :key="3"></el-option>
      </el-select>
      <el-select
        v-model="tableParams.isTicket"
        clearable
        placeholder="请选择是否到票"

        filterable
      >
        <el-option label="是" :value="0" :key="0"></el-option>
        <el-option label="否" :value="1" :key="1"></el-option>
      </el-select>
      <el-select
        v-model="tableParams.subjectId"
        clearable
        placeholder="请选择结算主体"
        filterable
      >
        <el-option
          v-for="item in channelSubjectList"
          :label="item.subjectName"
          :value="item.subjectId"
          :key="item.subjectId"
        ></el-option>
      </el-select>
      <el-input
        v-model="tableParams.corporateName"
        placeholder="请输入公司名称"
        clearable
      ></el-input>
      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>

    <div class="table-wrapper">
      <table-column
        @search="searchColumn"
        @refresh="toQuery"
        @change="changeColumn"
        :column="columns"
        :hide="hides"
        style="padding-bottom: 10px"
      >
        <el-button type="success" size="small" @click="add">新增</el-button>
        <el-button
          @click="
            downExcel('/reportFinance/down/finance', '财务录入表', tableParams)
          "
          type="warning"
          size="small"
          >下载
        </el-button>
      </table-column>

      <el-table
        v-loading="tableLoading"
        :data="tableData"
        height="80vh"
        :header-cell-style="{ background: '#fafafa' }"
        ref="report"
        row-key="id"
        lazy
        size="small"
        :summary-method="tableSummary"
        show-summary
        class="js-table"
        style="width: 100%"
      >
        <el-table-column
          v-for="(v, i) in checkColumns"
          :prop="v.field"
          :label="v.title"
          :width="v.width"
          :min-width="v.minWidth"
          :key="i"
          align="center"
        >
          <template v-slot="scope">
            <span v-if="v.field === 'isPayment'">
              {{ scope.row.isPayment === 0 ? "是" : "否" }}
            </span>
            <span v-else-if="v.field === 'isTicket'">
              {{ scope.row.isTicket === 0 ? "是" : "否" }}
            </span>
            <span v-else-if="v.field === 'invoiceContent'">
              {{
                scope.row.invoiceContent == 0
                  ? "信息服务费"
                  : scope.row.invoiceContent == 1
                  ? "广告发布费"
                  : scope.row.invoiceContent == 2
                  ? "技术服务费"
                  : "其他费用"
              }}
            </span>
            <span v-else>{{ scope.row[v.field] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="160">
          <template v-slot="scope" align="center">
            <el-button @click="update(scope.row)" type="success" size="mini"
              >编辑</el-button
            >
            <el-button @click="remove(scope.row)" type="warning" size="mini"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :total="pagination.total"
        :pager-count="6"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :page-sizes="[10, 30, 60, pagination.total]"
        background
        layout="total,sizes,prev,pager,next"
        style="margin-top: 40px"
      />
    </div>
    <el-dialog
      v-model="dialogStatus"
      :close-on-click-modal="false"
      :title="title"
      @close="cancel"
    >
      <el-form
        :model="updateForm"
        label-width="auto"
        :rules="updateRules"
        ref="updateForm"
      >
        <el-form-item label="是否支付">
          <el-radio v-model="updateForm.isPayment" :label="0">是</el-radio>
          <el-radio v-model="updateForm.isPayment" :label="1">否</el-radio>
        </el-form-item>
        <el-form-item label="是否到票">
          <el-radio v-model="updateForm.isTicket" :label="0">是</el-radio>
          <el-radio v-model="updateForm.isTicket" :label="1">否</el-radio>
        </el-form-item>
        <el-form-item label="公司名称">
          <el-input v-model="updateForm.corporateName"></el-input>
        </el-form-item>
        <el-form-item label="账单金额">
          <el-input v-model="updateForm.billAmount"></el-input>
        </el-form-item>
        <el-form-item label="发票号码">
          <el-input v-model="updateForm.invoiceNumber" style="width: 100%">
          </el-input>
        </el-form-item>
        <el-form-item label="发票金额">
          <el-input v-model="updateForm.invoiceValue" style="width: 100%">
          </el-input>
        </el-form-item>
        <el-form-item label="发票内容">
          <el-radio-group v-model="updateForm.invoiceContent">
            <el-radio label="0">信息服务费</el-radio>
            <el-radio label="1">广告发布费</el-radio>
            <el-radio label="2">技术服务费</el-radio>
            <el-radio label="3">其他费用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="业务月份">
          <el-date-picker
            v-model="updateForm.businessMonth"
            type="month"
            placeholder="选择业务月份"
            format="YYYYMM"
            value-format="YYYYMM"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="发票日期">
          <el-date-picker
            style="width: 100%"
            v-model="updateForm.invoiceDate"
            format="YYYYMMDD"
            value-format="YYYYMMDD"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="支付日期">
          <el-date-picker
            style="width: 100%"
            v-model="updateForm.paymentDate"
            format="YYYYMMDD"
            value-format="YYYYMMDD"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="未出金额">
          <el-input
            type="number"
            v-model="updateForm.outstandingAmount"
          ></el-input>
        </el-form-item>
        <el-form-item label="付款金额">
          <el-input type="number" v-model="updateForm.payment"></el-input>
        </el-form-item>
        <el-form-item label="付款主体">
          <el-select
            v-model="updateForm.subjectId"
            clearable
            placeholder="请选择付款主体"
            filterable
            style="width: 100%"
          >
            <el-option
              v-for="item in channelSubjectList"
              :label="item.subjectName"
              :value="item.subjectId"
              :key="item.subjectId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="updateForm.remark"></el-input>
        </el-form-item>
        <el-form-item>
          <div style="text-align: right">
            <el-button @click="cancel">取消</el-button>
            <el-button
              type="primary"
              @click="title === '新增' ? addSave() : updateSave()"
              >确定</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import TableColumn from '@/components/TableColumn'
import initTableMixin from '@/mixins/initTable'
import { downExcelMixin } from '@/mixins/downExcel'
import { removeFinance, addFinance, updateFinance } from '@/api/reportFinance'
import { formatDate, SIMPLE_MONTH_PATTERN } from '@/util/format'
import { getSubjectInfo } from '@/api/manage/channel/channel'



export default {
  name: 'channelSubject',
  components: {
    TableColumn
  },
  mixins: [initTableMixin, downExcelMixin],
  data () {
    return {
      columns: [
        { field: 'reportId', title: '唯一id' },
        { field: 'businessMonth', title: '业务月份' },
        { field: 'corporateName', title: '公司名称' },
        { field: 'subjectName', title: '付款主体名称' },
        { field: 'billAmount', title: '账单金额' },
        { field: 'invoiceValue', title: '发票金额' },
        { field: 'invoiceContent', title: '发票内容' },
        { field: 'invoiceDate', title: '发票日期' },
        { field: 'invoiceNumber', title: '发票号码' },
        { field: 'isPayment', title: '是否支付' },
        { field: 'isTicket', title: '是否到票' },
        { field: 'outstandingAmount', title: '未出金额' },
        { field: 'payment', title: '付款金额' },
        { field: 'paymentDate', title: '支付日期' },
        { field: 'remark', title: '备注' }
      ],
      hides: [
        'uniWinSmt', 'bidRate', 'cpcPrice', 'effectiveResSmt'
      ],
      date: [new Date(), new Date()],
      dialogStatus: false,
      updateForm: {},
      title: '',
      channelSubjectList: []
    }
  },
  created () {
    this.date[0].setMonth(new Date().getMonth(), 1)
    this.date[1].setMonth(new Date().getMonth(), 1)
    this.changeDate(this.date)
    this.getChannelSubjectList()
  },
  mounted () {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    getChannelSubjectList () {
      getSubjectInfo().then(res => {
        this.channelSubjectList = res.data
      })
    },
    // 新增按钮
    add () {
      this.dialogStatus = true
      this.title = '新增'
    },
    // 新增提交
    addSave () {
      addFinance(this.updateForm).then(res => {
        this.$message.success('新增成功')
        this.dialogStatus = false
        this.init()
      })
    },
    // 编辑按钮
    update (row) {
      this.dialogStatus = true
      this.title = '编辑'
      this.updateForm = Object.assign({}, row)
      if (this.updateForm.invoiceDate) this.updateForm.invoiceDate = this.updateForm.invoiceDate.toString()
      if (this.updateForm.paymentDate) this.updateForm.paymentDate = this.updateForm.paymentDate.toString()
      if (this.updateForm.businessMonth) this.updateForm.businessMonth = this.updateForm.businessMonth.toString()
    },
    // 编辑提交
    updateSave () {
      if (this.updateForm.outstandingAmount) this.updateForm.outstandingAmount = Number(this.updateForm.outstandingAmount)
      if (this.updateForm.payment) this.updateForm.payment = Number(this.updateForm.payment)
      if (this.updateForm.billAmount) this.updateForm.billAmount = Number(this.updateForm.billAmount)
      updateFinance(this.updateForm).then(res => {
        this.$message.success('编辑成功')
        this.dialogStatus = false
        this.init()
      })
    },
    // 关闭弹窗
    cancel () {
      this.dialogStatus = false
      this.updateForm = Object.assign({}, {})
    },
    beforeInit () {
      this.tableUrl = '/reportFinance/get/finance'
      this.tableParams.pageNum = this.pagination.pageNum
      this.tableParams.pageSize = this.pagination.pageSize
      return true
    },
    afterInit (res) {
      this.tableData = res.data.records
    },
    changeDate (date) {
      this.tableParams.startTime = date[0] ? formatDate(date[0], SIMPLE_MONTH_PATTERN) : date[0]
      this.tableParams.endTime = date[1] ? formatDate(date[1], SIMPLE_MONTH_PATTERN) : date[1]
    },
    tableSummary (row) {
      const arr = ['billAmount', 'invoiceValue', 'outstandingAmount', 'payment']
      const { data } = row
      const checklists = this.checkColumns.map(item => {
        return item.field
      })
      const out = []
      for (let i = 0; i < checklists.length; i++) {
        if (i === 0) {
          out[i] = '合计'
        } else {
          out[i] = arr.indexOf(checklists[i]) > -1 ? data.reduce((total, item) => { return total + Number(item[checklists[i]]) }, 0).toFixed(2) : '-'
        }
      }
      return out
    },
    sizeChange (e) {
      this.pagination.pageSize = e
      this.tableParams.pageSize = e
      this.init()
    },
    currentChange (e) {
      this.pagination.pageNum = e
      this.tableParams.pageNum = e
      this.init()
    },
    toQuery () {
      this.init()
    },
    remove (row) {
      this.$confirm('确定删除吗', '提示').then(() => {
        removeFinance({ reportId: row.reportId }).then(res => {
          this.$message.success('删除成功')
          this.init()
        })
      })
    }
  }
}
</script>

  <style scoped lang="scss">
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;

  & > * {
    margin-right: 15px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  & > .el-select,
  & > .el-input {
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: #ffffff;

  .table__operation {
    padding-bottom: 10px;
  }
}

.el-pagination {
  text-align: right;
}

::v-deep.el-table__expand-icon {
  width: auto !important;
}

::v-deep.el-table__body-wrapper {
  order: 0;
}
</style>
